import React from "react"
import styled, { withComponent } from "styled-components"
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import { Flex, Heading, Subhead } from "rebass"

const Circle = styled(Flex)`
  border: 3px solid ${props => props.borderColor || "#EEEEEE"};
  border-radius: 50%;
  background-color: ${props => props.bg || "inherit"};
  height: ${props => props.height || "8.25rem"};
  width: ${props => props.width || "8.25rem"};
  align-items: center;
  justify-content: center;

  color: ${props => props.color || "#333333"};

  &:hover {
    color: ${props => props.hoverColor || "#333333"};
  }
`.withComponent(({ hoverColor, ...rest }) => <Flex {...rest} />)

const Icon = styled(FontAwesomeIcon)`
  color: inherit;
`

const CircleIcon = props => (
  <Circle {...props}>
    <Icon icon={props.icon} size={props.size} />
  </Circle>
)

export default CircleIcon



// WEBPACK FOOTER //
// ./src/components/CircleIcon/index.js